import { render, staticRenderFns } from "./SalesTargetDetail.vue?vue&type=template&id=50584de0&scoped=true"
import script from "./SalesTargetDetail.vue?vue&type=script&lang=js"
export * from "./SalesTargetDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesTargetDetail.vue?vue&type=style&index=0&id=50584de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50584de0",
  null
  
)

export default component.exports